import * as React from 'react';
import { scrollToAnchor } from '@cian/newbuilding-utils';
import { useSelector } from 'react-redux';

import { trackOffersReliableLabelClick, TReliableLabel } from './tracking';
import { ReliableBlock } from '../../components/ReliableBlock';
import { ReliableBlockRedesigned } from '../../components/ReliableBlockRedesigned';
import { isReliableHouseSelector } from '../../selectors/newbuilding';
import { getSelectedHouseId } from '../../selectors/offers';
import { reliabilityEnabledSelector, reliabilitySelector } from '../../selectors/reliability';

export function ReliableBlockContainer() {
  const isReliable = useSelector(isReliableHouseSelector);
  const isReliabilityV2Enabled = useSelector(reliabilityEnabledSelector);
  const reliability = useSelector(reliabilitySelector);
  const houseId = useSelector(getSelectedHouseId);
  const reliableText = houseId ? 'Надежность корпуса проверена' : 'Есть корпуса, проверенные на надежность';

  const onReliableLabelClick = (label: TReliableLabel) => (event: React.MouseEvent<HTMLElement>) => {
    scrollToAnchor({
      anchor: '#reliable',
      offset: 0,
      hasRelocation: false,
      hasAnimation: true,
    })(event);
    trackOffersReliableLabelClick(label);
  };

  if (!isReliabilityV2Enabled) {
    return isReliable ? (
      <ReliableBlock text={reliableText} onClick={onReliableLabelClick('flats_reliable_dev')} />
    ) : null;
  }

  return (
    <ReliableBlockRedesigned
      reliability={reliability}
      onReliableClick={onReliableLabelClick('flats_reliable_dev')}
      onProblemClick={onReliableLabelClick('flats_problem_building')}
    />
  );
}
